import React from "react";
import Highcharts from "highcharts";
import { Theme } from "@mui/material";
import { renderToString } from "react-dom/server";
import { ChartTooltip } from "@components/Tooltip/ChartTooltip";

export const splitFormatter = ({
  formatter,
  point,
  theme,
}: {
  formatter: (value?: string | number | null) => React.ReactNode;
  point?: Highcharts.TooltipFormatterContextObject;
  theme?: Theme;
}) => {
  if (!point || !theme) return "";

  return renderToString(
    <ChartTooltip theme={theme}>
      <div
        style={{
          display: "flex",
          gap: "6px",
          alignItems: "center",
          fontSize: theme.typography.caption.fontSize,
          lineHeight: theme.typography.caption.lineHeight,
          color: theme.palette.text.onTooltipPrimary,
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: point.color as string,
            alignItems: "center",
          }}
        />
        <div
          style={{
            maxWidth: "130px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {point.series.userOptions.name}
        </div>
        <div
          style={{
            lineHeight: theme.typography.caption.lineHeight,
            fontWeight: 600,
          }}
        >
          {formatter(point.y)}
        </div>
      </div>
    </ChartTooltip>
  );
};
